import { render, staticRenderFns } from "./Designset.vue?vue&type=template&id=7f4fa5e3&scoped=true&"
import script from "./Designset.vue?vue&type=script&lang=js&"
export * from "./Designset.vue?vue&type=script&lang=js&"
import style0 from "./Designset.vue?vue&type=style&index=0&id=7f4fa5e3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4fa5e3",
  null
  
)

export default component.exports